import Constants from "./constants";
const stc = require("string-to-color");
const Color = require("color");
const dayjs = require("dayjs");
let duration = require("dayjs/plugin/duration");
dayjs.extend(duration);
let relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const Utils = {
  parseMinutesToHours(n) {
    let num = n;
    let hours = num / 60;
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
    if (rminutes < 10) rminutes = "0" + rminutes;
    return rhours + ":" + rminutes;
  },
  parseMinutesToSleepHours(n) {
    let num = n;
    let hours = num / 60;
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
    if (rminutes < 10) rminutes = "0" + rminutes;
    return `${rhours}h ${rminutes}m`;
  },
  countSleepStatus(sleepStatuses) {
    return sleepStatuses.reduce((chars, ch) => {
      if (!chars[ch]) {
        chars[ch] = 1;
      } else {
        chars[ch] += 1;
      }
      return chars;
    }, []);
  },
  formatPeriod(period) {
    if (period && period.length == 2) {
      let from = dayjs(period[0]).format(Constants.PERIOD_FORMAT);
      let to = dayjs(period[1]).format(Constants.PERIOD_FORMAT);
      return `${from} - ${to}`;
    }
    return "";
  },
  formatTimestampToTimeAgo(timestamp) {
    return dayjs(timestamp).fromNow();
  },
  formatTimestamp(unixTimestamp) {
    if (isNaN(parseInt(unixTimestamp))) return "-";
    return dayjs(parseInt(unixTimestamp)).format(Constants.MDY_TS_FORMAT);
  },
  formatDateTime(ts) {
    if (isNaN(parseInt(ts))) return "-";
    return dayjs(parseInt(ts)).format(
      Constants.TABLE_DAY_OF_WEEK_DATETIME_FORMAT
    );
  },
  formatDateTimeYear(ts) {
    if (isNaN(parseInt(ts))) return "-";
    return dayjs(parseInt(ts)).format(
      Constants.TABLE_DAY_OF_WEEK_DATETIME_YEAR_FORMAT
    );
  },
  formatDateTimeStamp(ts) {
    if (isNaN(parseInt(ts))) return "-";
    return dayjs(parseInt(ts)).format(
      Constants.TABLE_DATETIME_YEAR_FORMAT
    );
  },
  formatTimeStampToAmPM(ts) {
    if (!ts) return "-";
    return dayjs(ts).format(
      Constants.TABLE_DATETIME_YEAR_FORMAT
    );
  },
  formatDob(dt) {
    if (new Date(dt) instanceof Date)
      return dayjs(dt).format(Constants.TABLE_DOB_FORMAT);
    else return "-";
  },
  formatTime(ts) {
    if (isNaN(parseInt(ts))) return "-";
    return dayjs(parseInt(ts)).format(Constants.TABLE_TIME_FORMAT);
  },
  formatToTimeStamp(ts) {
    if (isNaN(parseInt(ts))) return "-";
    return dayjs(parseInt(ts)).format(Constants.TABLE_DATETIME_YEAR_FORMAT);
  },
  formatDuration(durationMs) {
    if (isNaN(parseInt(durationMs))) return "-";
    return dayjs.duration(parseInt(durationMs)).format("HH:mm:ss");
  },
  formatDistance(distanceM) {
    return distanceM / 1000;
  },
  formatSpeed(distanceM, durationMs) {
    if (distanceM <= 0 || durationMs <= 0) return "-";

    let durationS = durationMs / 1000;
    let speedInKmPerHour = (distanceM * 0.001 * 60 * 60) / durationS;

    // return Math.floor(speedInKmPerHour * 100).toFixed(2) / 100; // in km/hr
    return ((speedInKmPerHour * 100) / 100).toFixed(2); // in km/hr
  },
  formatPace(paceInS) {
    let paceInMs = paceInS * 1000;
    return dayjs.duration(paceInMs).format("mm:ss");
  },
  getSwimMainStroke(swimType) {
    let mainStroke = Constants.SWIM_MAIN_STROKES[swimType - 1];
    return mainStroke || "Unknown";
  },
  getRandomColorCode(index, datasetLength) {
    let colorIndex = (360 * (index + 1.25)) / datasetLength;
    let colorHex = this.hslToHex(colorIndex, 100, 50);
    return colorHex;
  },
  stringToHexColor(text) {
    const colorStc = stc(text);
    let color = Color(colorStc);

    if (color.isLight()) {
      color = color.darken(0.15);
    }
    return color.saturate(0.4).hex();
  },
  hslToHex(h, s, l) {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n) => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color)
        .toString(16)
        .padStart(2, "0"); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  },
  getSleepScoreColor(score) {
    if (score <= Constants.SLEEP_DANGER) {
      return "danger";
    } else if (score <= Constants.SLEEP_WARNING) {
      return "warning";
    } else return "success";
  },
  getRecoveryScoreColor(score) {
    if (score <= Constants.RECOVERY_DANGER) {
      return "danger";
    } else if (score <= Constants.RECOVERY_WARNING) {
      return "warning";
    } else return "success";
  },
  getBmiCategoryColor(bmiCategory) {
    let category = bmiCategory.toLowerCase();

    if (category == "underweight" || category == "overweight") {
      return "bg-warning";
    } else if (category == "obese") {
      return "bg-danger";
    } else return "bg-success";
  },
  getWorkoutIcon(workoutType) {
    return `/img/icons/ic_workout_${workoutType}.svg`;
  },
  // TODO: Move to backend when data analysis engine is ready
  getRecommendation(recoveryScore) {
    if (recoveryScore <= 0) return "";
    /**
     * Very Poor:
     * Recovery is in danger zone
     *
     * Poor:
     * Recovery in warning zone
     */
    if (recoveryScore <= Constants.RECOVERY_DANGER)
      return "Recovery is low. Try to spend extra time on recovery activities today for better health and well-being";
    else if (recoveryScore <= Constants.RECOVERY_WARNING)
      return "Recovery is moderate. Go for lower strain activities to balance fitness gains and recovery.";
    else if (recoveryScore <= Constants.MAX_RECOVERY_SCORE)
      return "Recovery is high. Aim for higher strain activities to gain fitness.";
    else
      return "Recovery is pending. Recovery score will be calculated once the sleep data is processed.";
  },
  camelizeString(string, delimiter) {
    if (!string) {
      return string;
    }

    let stringArray = string.split(delimiter);
    let camelizedStr = '';
    for (let str of stringArray) {
      camelizedStr = camelizedStr + str.charAt(0).toUpperCase() + str.slice(1);
      camelizedStr = camelizedStr + ' ';
    }
    return camelizedStr;
  },
  formatDurationInSec(seconds) {
    const hours = Math.floor(seconds / 3600); // 1 hour = 3600 seconds
    const minutes = Math.floor((seconds % 3600) / 60); // 1 minute = 60 seconds
    const secs = seconds % 60;
    if (hours <= 0) {
      return `${minutes}m ${secs}s`;
    }

    return `${hours}h ${minutes}m ${secs}s`;
  },
  formatDurationInHrsAndMins(seconds) {
    if (seconds == 0) {
      return `0s`;
    }
    const hours = Math.floor(seconds / 3600); // 1 hour = 3600 seconds
    const minutes = Math.floor((seconds % 3600) / 60); // 1 minute = 60 seconds
    const remainingSecs = Math.floor(seconds % 60);

    if (hours <= 0 && minutes <= 0) {
      return `${remainingSecs}s`;
    }

    if (hours <= 0) {
      return `${minutes}m ${remainingSecs}s`;
    }

    return `${hours}h ${minutes}m ${remainingSecs}s`;;
  },
  formatToBucketFormat(ts) {
    if (isNaN(parseInt(ts))) return "-";
    return dayjs(parseInt(ts)).format(
      Constants.BUCKET_FORMAT
    );
  },
  getPerformanceRecommendation(recoveryScore) {
    if (recoveryScore <= 0) return "";
    if (recoveryScore <= Constants.RECOVERY_DANGER)
      return "HRV is lower than usual, which may indicate increased stress or fatigue. It is important to ensure proper rest and recovery.";
    else if (recoveryScore <= Constants.RECOVERY_WARNING)
      return "Stress levels appear higher than usual. Prolonged stress can affect your overall well-being. Make sure to prioritize rest and self-care.";
    else
      return "";
      //return "Your RHR is higher than usual. A consistently elevated heart rate could be a sign of stress or overexertion. Monitor your activity levels, hydration, and sleep patterns.";
  },
  numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  },
  arrayCountByVals(arr) {
    const groupedCounts = arr.reduce((acc, val) => {
      acc[val] = (acc[val] || 0) + 1;
      return acc;
    }, {});

    return groupedCounts;
  },
  getTimeDiffInMins(fromtime, totime) {
    let fromMins = this.formatTime(fromtime);
    let toMins = this.formatTime(totime);
    const ft = dayjs(`2025-01-01 ${fromMins}`);
    const tt = dayjs(`2025-01-01 ${toMins}`);
    // const ft = dayjs(fromMins);
    // const tt = dayjs(toMins);
    const mins = tt.diff(ft, "minutes", true);

    let timeDiffObj = {
      positiveVal: mins > 0 ? true : false,
      minutes: mins > 0 ? mins : (-1 * mins)
    };
    return timeDiffObj;
  },
  addMinutes(date, minutes) {
    return dayjs(date).add(minutes, 'minutes').toDate()
  },
  getWorkoutDescriptionFromID(workoutTypeId, dataWorkoutTypes) {
    let workoutDesc = 'Indoor';
    for (let dateWorkoutType of dataWorkoutTypes) {
      if (dateWorkoutType.workout_type == workoutTypeId) {
        workoutDesc = dateWorkoutType.workout_type_record.workout_name;
        break;
      }
    }

    return workoutDesc;
  },
  getHrZoneRangeHeartRates(age) {
    let MAX_HR = 220 - age;
    let REST_ZONE = 0.5, WARM_UP = 0.6, FAT_BURNING = 0.7, AEROBIC = 0.8, ANAEROBIC = 0.9;

    let restZoneHr = parseInt(REST_ZONE * MAX_HR);
    let warmUpZoneHr = parseInt(WARM_UP * MAX_HR);
    let fatBurningZoneHr = parseInt(FAT_BURNING * MAX_HR);
    let aerobicZoneHr = parseInt(AEROBIC * MAX_HR);
    let anAerobicZoneHr = parseInt(ANAEROBIC * MAX_HR);

    return { restZoneHr, warmUpZoneHr, fatBurningZoneHr, aerobicZoneHr, anAerobicZoneHr };
  },
  calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();

    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    if (!hasHadBirthdayThisYear) {
      age--;
    }

    return age;
  },
  formatNumber(num) {
    const x = num.toString().split('.');
    let intPart = x[0];
    const decimalPart = x.length > 1 ? '.' + x[1] : '';

    // Extract last 3 digits (for thousand group)
    const lastThree = intPart.slice(-3);
    const otherNumbers = intPart.slice(0, -3);

    if (otherNumbers !== '') {
      intPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    return intPart + decimalPart;
  },
  formatToHHMM_UTC(timestamp) {
    const ts = Number(timestamp);

    if (!Number.isFinite(ts)) {
      console.error("Invalid timestamp:", timestamp);
      return "--:--";
    }

    const date = new Date(ts);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }
};


export default Utils;
